// Root Layout 的所有 provider 都在这里处理
'use client';

import DeferredRootHandlers from '@/components/deferred-root-handlers';
import GlobalTrackerSync from '@/components/global-tracker-sync';
import HostedCheckoutReturnConfirmHandler from '@/components/hosted-checkout-return-confirm-handler';
import { LoginModalHost } from '@/components/login-modal';
import ReaderExitLoginPrompt from '@/components/reader-exit-login-prompt';
import I18NRootLayout from '@/i18n/i18n-root-layout';
import AppBrandingBootstrap from '@/providers/app-branding/bootstrap';
import AuthSessionBootstrap from '@/providers/root/auth-session-bootstrap';
import PayPalSdkPreload from '@/providers/root/paypal-sdk-preload';

import TanstackQueryProvider from './tanstack-query';
import { ToastProvider } from './toast';

interface IProps {
    children: React.ReactNode;
}

export default function RootProvider({ children }: Readonly<IProps>) {
    return (
        <I18NRootLayout>
            <ToastProvider>
                <TanstackQueryProvider>
                    <AppBrandingBootstrap />
                    <DeferredRootHandlers />
                    <HostedCheckoutReturnConfirmHandler />
                    <ReaderExitLoginPrompt />
                    <AuthSessionBootstrap />
                    <PayPalSdkPreload />
                    <GlobalTrackerSync />
                    <LoginModalHost />
                    {children}
                </TanstackQueryProvider>
            </ToastProvider>
        </I18NRootLayout>
    );
}
